export const meta = {
  title: 'பில்லிங் & உங்கள் சந்தா',
  updatedAt: '2026-07-17',
  related: ['getting-started', 'staff'],
};

நீங்கள் செலுத்துவது தொடர்பான அனைத்தும் டாஷ்போர்டின் **பில்லிங்** பக்கத்தில் உள்ளன: உங்கள் திட்டம், சோதனை நிலை, அடுத்த பில்லிங் தேதி, தற்போது கட்டணம் விதிக்கப்படும் கடைகளின் எண்ணிக்கை, இதுவரை வெளியிடப்பட்ட ஒவ்வொரு விலைப்பட்டியலும். மர்மக் கட்டணங்கள் இல்லை — ஒவ்வொரு மாற்றமும் நீங்கள் படிக்கக்கூடிய தணிக்கைப் பதிவில் எழுதப்படுகிறது.

## சோதனைக் காலம்

உங்கள் கணக்கு முழு அணுகலுடன் **14 நாள் இலவசச் சோதனையில்** தொடங்குகிறது — அட்டை பதிவு இல்லை, எதுவும் வசூலிக்கப்படாது. சோதனையில் எத்தனை நாட்கள் மீதம் என்பதை பில்லிங் பக்கம் துல்லியமாகக் காட்டும். சோதனைக் காலத்தில் ரத்து செய்தால் நீங்கள் எதுவும் செலுத்தத் தேவையில்லை.

## மாதாந்திர விலைப்பட்டியல் எப்படி வேலை செய்கிறது

பில்லிங் **பயன்பாட்டுக்குப் பின்** நடைபெறுகிறது: ஒவ்வொரு மாதமும் 1ஆம் தேதி நள்ளிரவுக்குச் சிறிது நேரம் கழித்து, முடிந்த மாதத்தை உள்ளடக்கிய ஒரு விலைப்பட்டியல் வெளியிடப்படும். அதில் உங்கள் திட்டம், கூடுதல் கடைகள், மாத நடுவில் செய்த மாற்றங்களின் விகிதாசாரக் கட்டணங்கள் அனைத்தும் வரிசையாக இருக்கும் — மொத்தத் தொகை ஒருபோதும் அதிர்ச்சியாக இருக்காது.

## விலைப்பட்டியலைச் செலுத்துதல்

பில்லிங் பக்கத்தில் செலுத்தப்படாத ஒவ்வொரு விலைப்பட்டியலிலும் **இப்போது செலுத்து** பொத்தான் இருக்கும். அது பாதுகாப்பான FPX கட்டணப் பக்கத்தைத் திறக்கும் — எந்த மலேசிய வங்கிக் கணக்கிலிருந்தும் நேரடியாகச் செலுத்துங்கள். வங்கி உறுதிப்படுத்தியதும் விலைப்பட்டியல் தானாக _செலுத்தப்பட்டது_ என மாறும்; பொதுவாக சில நொடிகளில்.

கட்டண இணைப்பு காலாவதியாகிவிட்டால், விலைப்பட்டியலுக்கு அருகிலுள்ள புதுப்பிப்புச் செயல் மூலம் புதிய இணைப்பைப் பெறுங்கள். கவனிக்கவும்: ஒரு விலைப்பட்டியலுக்கு **புதிய** இணைப்பு மட்டுமே பணத்தைச் செலுத்த முடியும் — இருமுறை வசூல் ஆபத்தைத் தவிர்க்கப் பழைய இணைப்புகள் நிராகரிக்கப்படும்.

## கடை சேர்த்தல்

**கடைகள்** பக்கத்தில் கடைகளைச் சேருங்கள். உறுதிப்படுத்தும் முன், விகிதாசாரக் கட்டணத்தின் நேரடி முன்னோட்டத்தைப் பார்ப்பீர்கள் — நடப்பு மாதத்தின் மீதமுள்ள நாட்களுக்கு மட்டுமே செலுத்துவீர்கள்; அந்தத் தொகை உங்கள் அடுத்த விலைப்பட்டியலில் சேரும். புதிய கடை உடனே பயன்பாட்டுக்குத் தயார் — தனி வரிசையும் தனி QR குறியீடும் உடன் கிடைக்கும்.

## கடை நீக்குதல்

கடை நீக்கம் **மாத இறுதியில்** நடைமுறைக்கு வரும். அதுவரை அது இயங்கிக்கொண்டே இருக்கும் — அந்த நாட்களுக்கு நீங்கள் ஏற்கனவே செலுத்திவிட்டீர்கள் — பிறகு அடுத்த விலைப்பட்டியலிலிருந்து விலகும். நிலுவையில் உள்ள நீக்கத்தையும் அதன் நடைமுறை தேதியையும் பில்லிங் பக்கம் பட்டியலிடுவதால் யூகிக்க வேண்டியதில்லை.

## SST மற்றும் வரி விலைப்பட்டியல்கள்

உங்கள் வணிகம் SST பதிவு பெற்றிருந்தால், பில்லிங் பக்கத்தில் வரி அட்டையைத் திறங்கள் (உரிமையாளருக்கு மட்டும்), அதை இயக்கி, SST எண்ணையும் சட்ட நிறுவன விவரங்களையும் உள்ளிடுங்கள். அதன் பிறகு ஒவ்வொரு விலைப்பட்டியலிலும் SST வரியுடன் வரும்; அதன் PDF முறையான வரி விலைப்பட்டியலாக உருவாக்கப்படும்.

## விலைப்பட்டியல் PDF-கள்

ஒவ்வொரு விலைப்பட்டியலிலும் **PDF** பொத்தான் உண்டு — உங்கள் கணக்காளருக்கோ உங்கள் ஆவணங்களுக்கோ பதிவிறக்குங்கள். செலுத்தப்பட்ட விலைப்பட்டியல்கள் எப்போது, எப்படிச் செலுத்தப்பட்டன என்பதைக் காட்டும்.

## தணிக்கைப் பாதை

பில்லிங் பக்கம் உங்கள் **சந்தா நிகழ்வுகள்** பேரேட்டுடன் முடிகிறது: ஒவ்வொரு திட்ட மாற்றம், கடை சேர்ப்பு, நீக்கம், கட்டணம் — அனைத்தும் நேர முத்திரையுடன். விலைப்பட்டியலில் ஏதேனும் எண் புரியவில்லை என்றால், அது எங்கிருந்து வந்தது என்பதை இந்தப் பேரேடு சொல்லும்.
